/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BookingDay } from './bookingDay';


/**
 * One week of free slots. ``no_more_slots``: nothing is free in this or any later week.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface BookingWeek { 
    page: number;
    automaticPageSkip: boolean;
    noMoreSlots: boolean;
    selectedDate: string | null;
    days: Array<BookingDay>;
}
export const BookingWeek_page_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingWeek_automaticPageSkip_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingWeek_noMoreSlots_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingWeek_selectedDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingWeek_days_Validators: ValidatorFn[] =
    [  Validators.required, ];


